import React, { useState } from 'react';
import { Button } from '../UI/Button';
import { useToast } from '../UI/ToastProvider';

interface WhatsAppMetaSetupInstructionsProps {
  webhookUrl: string;
  verifyToken: string;
}

export const WhatsAppMetaSetupInstructions: React.FC<WhatsAppMetaSetupInstructionsProps> = ({
  webhookUrl,
  verifyToken,
}) => {
  const { addToast } = useToast();
  const [copiedField, setCopiedField] = useState<'url' | 'token' | null>(null);

  const handleCopy = async (text: string, field: 'url' | 'token') => {
    if (!text)
    {
      return;
    }

    try
    {
      await navigator.clipboard.writeText(text);
      setCopiedField(field);
      addToast('Copiado para a área de transferência', 'success');
      setTimeout(() => setCopiedField(null), 2000);
    }
    catch
    {
      addToast('Não foi possível copiar', 'error');
    }
  };

  return (
    <div className="space-y-3">
      <div className="border border-gray-200 rounded-md p-3 bg-white">
        <div className="flex items-center justify-between mb-2">
          <label className="text-sm font-semibold text-gray-700">URL de callback</label>
          <Button
            variant="secondary"
            size="sm"
            type="button"
            disabled={!webhookUrl}
            onClick={() => void handleCopy(webhookUrl, 'url')}
          >
            {copiedField === 'url' ? 'Copiado' : 'Copiar'}
          </Button>
        </div>
        <div className="bg-gray-50 border border-gray-200 rounded px-3 py-2">
          <code className="text-xs text-gray-800 break-all">{webhookUrl || '—'}</code>
        </div>
      </div>

      <div className="border border-gray-200 rounded-md p-3 bg-white">
        <div className="flex items-center justify-between mb-2">
          <label className="text-sm font-semibold text-gray-700">Verificar token</label>
          <Button
            variant="secondary"
            size="sm"
            type="button"
            disabled={!verifyToken}
            onClick={() => void handleCopy(verifyToken, 'token')}
          >
            {copiedField === 'token' ? 'Copiado' : 'Copiar'}
          </Button>
        </div>
        <div className="bg-gray-50 border border-gray-200 rounded px-3 py-2">
          <code className="text-xs text-gray-800 break-all">{verifyToken || '—'}</code>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-md p-3">
        <h4 className="text-sm font-semibold text-blue-900 mb-2">
          Como configurar no painel da Meta
        </h4>
        <ol className="text-xs text-blue-800 space-y-1.5 list-decimal list-inside">
          <li>
            Abra o{' '}
            <a
              href="https://developers.facebook.com/apps/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-blue-900"
            >
              painel de desenvolvedor da Meta
            </a>
            {' '}e selecione o aplicativo
          </li>
          <li>
            Em <strong>Casos de uso</strong>, abra <strong>Conectar-se com clientes pelo WhatsApp</strong>
          </li>
          <li>Vá em <strong>Configuração</strong></li>
          <li>
            Na seção <strong>Webhook</strong>, cole a <strong>URL de callback</strong> e o <strong>Verificar token</strong> acima
          </li>
          <li>Clique em <strong>Verificar e salvar</strong></li>
          <li>
            Em <strong>Campos do webhook</strong>, assine o campo <strong>messages</strong>
          </li>
          <li>Volte a esta tela e clique em <strong>Finalizar configuração</strong></li>
        </ol>
      </div>
    </div>
  );
};
